namespace TabAurous.Stock {
    export namespace CommonStockPostingService {
        export const baseUrl = 'Stock/CommonStockPosting';

        export declare function CommonStockPosting(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            CommonStockPosting = "Stock/CommonStockPosting/CommonStockPosting"
        }

        [
            'CommonStockPosting'
        ].forEach(x => {
            (<any>CommonStockPostingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
